module.exports = __webpack_public_path__ + "static/media/Green_Success.d5789c2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/confirmation/icons/Green_Success.svg
// module id = 99
// module chunks = 0